import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { extras } from "../i18n";

export default function Footer() {
  const { t, lang } = useLang();
  return (
    <footer className="border-t-2 border-topacio-ink bg-topacio-ink text-white">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <img src="/logo-topacio.jpg" alt="Rent a Moto Topacio"
            className="h-14 w-auto rounded-md border-2 border-white/20" />
          <p className="text-sm text-zinc-400 mt-5 max-w-xs">{t.footer.tagline}</p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-brand font-extrabold mb-4">{t.footer.links}</h4>
          <div className="space-y-2">
            {[["#fleet", t.nav.fleet], ["#experience", t.nav.experience], ["#routes", t.nav.routes], ["#galeria", t.footer.gallery], ["#faq", t.nav.faq], ["#contact", t.nav.contact]].map(([href, label]) => (
              <a key={href} href={href} className="block text-sm text-zinc-400 hover:text-brand transition-colors">{label}</a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-brand font-extrabold mb-4">Legal</h4>
          <div className="space-y-2">
            <Link to="/legal" data-testid="footer-legal-link" className="block text-sm text-zinc-400 hover:text-brand transition-colors">{t.footer.legal}</Link>
            <Link to="/privacidad" data-testid="footer-privacy-link" className="block text-sm text-zinc-400 hover:text-brand transition-colors">{t.footer.privacy}</Link>
            <Link to="/cookies" data-testid="footer-cookies-link" className="block text-sm text-zinc-400 hover:text-brand transition-colors">{t.footer.cookiesPolicy}</Link>
            <Link to="/condiciones" data-testid="footer-conditions-link" className="block text-sm text-zinc-400 hover:text-brand transition-colors">{t.footer.conditions}</Link>
            <Link to="/colaboradores" data-testid="footer-partners-link" className="block text-sm text-zinc-400 hover:text-brand transition-colors">{extras[lang]?.partnersLink || "Colaboradores"}</Link>
            <a href="/admin/login" data-testid="footer-admin-link" className="block text-sm text-zinc-600 hover:text-brand transition-colors">Admin</a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6">
        <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-500">
            © {new Date().getFullYear()} Rent a Moto Topacio · Tenerife. {t.footer.rights}
          </p>
          <a href="https://siempria.com" target="_blank" rel="noopener noreferrer" data-testid="siempria-credit"
            className="flex items-center gap-2 group">
            <span className="text-xs text-zinc-500 group-hover:text-zinc-300 transition-colors">{t.footer.developedBy}</span>
            <img src="/logo-siempria.png" alt="Siempria"
              className="h-8 w-auto opacity-80 group-hover:opacity-100 transition-opacity" />
          </a>
        </div>
      </div>
    </footer>
  );
}
